import React from "react";

import axios from "axios";

import { downloadOneFile } from "utils/file/download-file";
import { IRichTextPlaceholderProps } from "../interfaces";
import { getNestedObjValue } from "../helpers";
import { GT } from "components/index";

import "./file-placeholder.styles.scss";

export const FilePlaceholder = ({ rowData, value = undefined }: IRichTextPlaceholderProps) => {
    const { row, fieldName } = rowData;

    let content = value || getNestedObjValue(row, fieldName.split("."));

    const formatFileName = content?.substr(content?.lastIndexOf("/") + 1);

    if (!content) return <></>;

    const getUrl = (fileUrl) => {
        let correctFileUrl = "";
        if (!content.includes("http")) {
            const fileBaseURL: string = axios.defaults.baseURL?.replace(/\/api$/, "") as string;

            correctFileUrl = fileBaseURL + (fileUrl.includes("/media/") ? "" : "/media/") + fileUrl;
        }
        return correctFileUrl;
    };

    return (
        <div className="file-placeholder input-placeholder ">
            <GT.TooltipHOC tooltipContent={formatFileName} className="file-name">
                {formatFileName}
            </GT.TooltipHOC>
            <GT.Button
                withoutPerm
                icon={{ name: ["fas", "download"] }}
                onClick={() => downloadOneFile(getUrl(content), formatFileName)}
            ></GT.Button>
        </div>
    );
};
